(function (ws) {
    'use strict';
    ws.views.addToCartPDP = ws.views.googleAnalytics.extend({

        DEFAULT_QUANTITY_INPUT: 1,

        events: {
            'click .add-cart-btn': 'pdpAddToCart'
        },

        /**
         * Initialize
         */
        initialize: function () {
            this.$quantityInput = this.$('.inputQuantity');
            this.$productName = this.$('.productName');
            this.$productcodeInput = this.$('.productcodeInput');
            this.$productPrice = this.$('#productPrice');
            this.$productCategory = this.$('#categoriesInput');
            this.$currencyIso = this.$('#currencyIso');
            this.$gaTrackingId = this.$('#gaTrackingId');
            this.$idProduct = this.$('#idProduct');
            this.$brandName = this.$('#brandName');
            this.confirmModalId = this.$('.crt-clear-confirm').attr('id');

            this.$cartLabel = $('.mic-badge');

            this.$mainContent = $('#tab_content');
            this.$techSpecificationTitle = $('#tech-specification-title');
            this.$saveButton = this.$('.add-cart-btn');

            this.$apiError = this.$('.api-error-message');
            this.$quantityError = this.$('.error-message-qty');
            this.$invalidError = this.$('.error-message-invalid');
            this.$inactiveError = this.$('.error-message-inactive');
            this.$activeVendorProduct = this.$('#activeVendorProduct');

            this.$quantityInput.val(this.DEFAULT_QUANTITY_INPUT);

            ws.views.googleAnalytics.prototype.initialize.call(this);

            this.eventAgg.on('productFound', this.showTabs, this);
            $(document.body).on('click', '#tech-specifications label', this.toggleSpecifications.bind(this));
            $('.yes').on('click', this.clearCart.bind(this));
        },

        /**
         *
         */
        clearCart: function (e) {
            this.eventAgg.trigger(this.confirmModalId + 'close');
            this.pdpAddToCart(e, true);
        },

        /**
         * Hide and show Specifications
         */
        toggleSpecifications(ev) {
            $(ev.currentTarget).toggleClass('minus-icon');
            $(ev.currentTarget).closest('div').find('.form-group').toggle();
        },

        /**
         * Show tabs only when tech specifications are coming
         */
        showTabs (spexWidget) {
            if (spexWidget.components.indexOf('specs') > -1) {
                this.$techSpecificationTitle.css('display', 'inline-block');
                this.toggleFirstSpecification();
                this.$mainContent.show();
            }
        },

        toggleFirstSpecification() {
            const firstSpecification = $('#tech-specifications label:first');
            firstSpecification.toggleClass('minus-icon');
            firstSpecification.closest('div').find('.form-group').toggle();
        },

        /**
         * PDP Add to Cart
         */
        pdpAddToCart: function (e, proceed) {
            const pdpQuantity = this.$quantityInput.val();
            const filter = /^[1-9][0-9]{0,3}$/;

            this.$apiError.hide();
            this.$quantityError.hide();
            this.$invalidError.hide();
            this.$inactiveError.hide();
            this.$quantityInput.removeClass('error');

            if (this.$activeVendorProduct.val() === 'false') {
                this.$inactiveError.show();
                this.$quantityInput.addClass('error');
            }
            else if ($.trim(pdpQuantity).length === 0) {
                this.$quantityError.show();
                this.$quantityInput.addClass('error');
            }
            else if (filter.test(pdpQuantity)) {
                //enable Spinner
                this.$saveButton.addClass('spinner-before narrow-btn').prop('disabled', true);

                const productName = this.$productName.val();
                const pdpCode = this.$productcodeInput.val();
                const qtyArray = new ws.models.pdpAddToCartModal();
                const pdpPrice = this.$productPrice.val();
                const currencyIso = this.$currencyIso.val();
                const gaTrackingId = this.$gaTrackingId.val();
                const idProduct = this.$idProduct.val();
                const brandName = this.$brandName.val();
                let pdpCategories = this.$productCategory.val();

                if (pdpCategories !== 'notPresent') {
                    pdpCategories = this.mapCategoryNamesToArray(pdpCategories);
                }

                this.gtmAddToCart(this.TYPE_ADD_PRODUCT_PAGE, productName, idProduct, pdpQuantity.toString(), pdpPrice.toString(), brandName, pdpCategories, currencyIso, gaTrackingId);

                dataLayerAA.cart = {};
                dataLayerAA.cart.category = 'cart';
                dataLayerAA.cart.type = 'add';
                dataLayerAA.cart.action = 'product page';
                dataLayerAA.product = [];

                let product = {};
                product.name = productName;
                product.id = idProduct;
                product.price = pdpPrice;
                product.category = pdpCategories;
                product.vendor = brandName;
                product.quantity = pdpQuantity;
                dataLayerAA.product.push(product);

                _satellite.track('event:cart');

                qtyArray.set({productCode: pdpCode});
                qtyArray.set({proceed: proceed ? true : false});
                qtyArray.set({qty: pdpQuantity});
                qtyArray.save().done(response => {

                    //disable spinner
                    this.$saveButton.removeClass('spinner-before narrow-btn').prop('disabled', false);
                    if (response.is3PLOrder) {
                        this.eventAgg.trigger(this.confirmModalId);
                    } else {
                        this.$cartLabel.text(response.data[0].totaItems);

                        // trigger update cart
                        this.eventAgg.trigger('updateCart', response.data[0].miniCartData);
                        this.eventAgg.trigger('showAddedNotification', response);
                        this.$quantityInput.val(this.DEFAULT_QUANTITY_INPUT);
                    }
                }).fail(() => {
                    this.$saveButton.removeClass('spinner-before narrow-btn').prop('disabled', false);
                    this.$apiError.show();
                });

            } else {
                this.$invalidError.show();
                this.$quantityInput.addClass('error');
            }
        },

        /**
         * transform category names to mapped array to use in analytics
         * @param {string} categoryNames
         */
        mapCategoryNamesToArray: function(categoryNames) {
            const categoryNamesArray = categoryNames.split(',');
            const categoryObjectArray = [];

            _.each(categoryNamesArray, category => {
                categoryObjectArray.push(category.replace(/\W/g, ''));
            });

            return categoryObjectArray;
        }
    });
})(westcon);
